export default __webpack_public_path__ + "static/premio2CO-15e72fe7b02701ee6b255998fdffbebd.png";